import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 64 } };
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/site/",
      redirect: "/"
    },
    {
      path: "/site/*",
      redirect: "/"
    },
    {
      path: "*",
      name: "Error",
      component: () => import("./views/Error")
    },
    {
      path: "/",
      name: "Home",
      component: () => import("./views/Home")
    },
    {
      path: "/builds",
      name: "Builds",
      component: () => import("./views/Builds")
    },
    {
      path: "/builds/:build",
      name: "Build",
      component: () => import("./views/Build")
    },
    {
      path: "/about",
      name: "About",
      component: () => import("./views/About")
    },
    {
      path: "/news",
      name: "News",
      component: () => import("./views/News")
    },
    {
      path: "/news/:article",
      name: "Article",
      component: () => import("./views/Article")
    },
    {
      path: "/contact",
      name: "Contact",
      component: () => import("./views/Contact")
    },
    {
      path: "/contact/thanks",
      name: "Thanks",
      component: () => import("./views/Thanks")
    }
  ]
});
